var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_5764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.375 17.1875C37.5831 17.1875 38.5625 16.2081 38.5625 15C38.5625 13.7919 37.5831 12.8125 36.375 12.8125C35.1669 12.8125 34.1875 13.7919 34.1875 15C34.1875 16.2081 35.1669 17.1875 36.375 17.1875Z",
    fill: "#D34646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 29.875L18 40.375",
    stroke: "#D34646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 21.1252V26.3752C46 31.9448 43.7875 37.2862 39.8492 41.2245C35.911 45.1627 30.5695 47.3752 25 47.3752H2.25L23.25 21.1252V16.7502C23.2546 13.9869 24.265 11.3198 26.0924 9.24698C27.9198 7.17417 30.4392 5.83744 33.1802 5.48645C35.9211 5.13546 38.6961 5.79422 40.9868 7.33968C43.2775 8.88515 44.9273 11.2116 45.6281 13.8846L51.25 17.6252L46 21.1252Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_5764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirds);
export default __webpack_public_path__ + "static/media/Birds.9a04ccdbbffd21d9702b887e52749e0c.svg";
export { ForwardRef as ReactComponent };